import { useMemo } from 'react';
import parse from 'html-react-parser';
import { prefixedClasNames } from '../../../utils/prefixedClassNames';
import { getWrapedChildren } from './getWrapedChildren';
var wrappers = [
    {
        targetTagName: 'video',
        wrapperTagName: 'span',
        wrapperClassName: prefixedClasNames('rich-text-content__video'),
    },
    {
        targetTagName: 'iframe',
        wrapperTagName: 'span',
        wrapperClassName: prefixedClasNames('rich-text-content__iframe'),
    },
    {
        targetTagName: 'table',
        wrapperTagName: 'div',
        wrapperClassName: prefixedClasNames('rich-text-content__table'),
    },
];
export function useRichTextWrappedChildren(props) {
    var result = useMemo(function () {
        if ('children' in props) {
            var children = getWrapedChildren(props.children, { wrappers: wrappers });
            return { children: children };
        }
        if ('html' in props) {
            var hasTargetElements = !!wrappers.find(function (_a) {
                var targetTagName = _a.targetTagName;
                return props.html.includes("<".concat(targetTagName));
            });
            if (hasTargetElements) {
                var children = getWrapedChildren(parse(props.html), { wrappers: wrappers });
                return { children: children };
            }
            return { dangerouslySetInnerHTML: { __html: props.html } };
        }
        return {};
    }, [props]);
    return result;
}
//# sourceMappingURL=useRichTextWrappedChildren.js.map